// src/services/emailService.js
import emailjs from '@emailjs/browser';
import { EMAILJS_CONFIG } from '../emailConfig';

/**
 * Invia un'email agli amministratori per una nuova prenotazione
 */
export const sendNewBookingEmail = async (bookingData, userDetails, adminEmails = []) => {
    try {
        const emailsToSend = adminEmails.length > 0 ? adminEmails : [EMAILJS_CONFIG.ADMIN_EMAIL];

        // Creiamo un array di Promises per inviare una mail singola a ciascun admin
        const sendPromises = emailsToSend.map(email => {
            const templateParams = {
                to_email: email,
                user_email: bookingData.userEmail || "email non fornita",
                user_name: userDetails?.firstName ? `${userDetails.firstName} ${userDetails.lastName}` : "Utente",
                event_name: bookingData.eventName,
                space_id: bookingData.spaceId,
                start_date: bookingData.startDate,
                end_date: bookingData.endDate || bookingData.startDate,
                start_time: bookingData.startTime,
                end_time: bookingData.endTime,
                description: bookingData.description || 'Nessuna descrizione'
            };

            return emailjs.send(
                EMAILJS_CONFIG.SERVICE_ID,
                EMAILJS_CONFIG.TEMPLATE_NEW_BOOKING,
                templateParams,
                EMAILJS_CONFIG.PUBLIC_KEY
            );
        });

        await Promise.all(sendPromises);

        console.log('Emails to admins sent successfully!');
        return true;
    } catch (err) {
        console.error('Failed to send email to admins:', err);
        return false;
    }
};

/**
 * Invia un'email all'utente in seguito ad accettazione o rifiuto
 */
export const sendStatusUpdateEmail = async (userEmail, userName, spaceId, eventName, status, rejectionReason = '') => {
    try {
        const statusText = status === 'confirmed' ? "ACCETTATA" : "RIFIUTATA";
        const reasonText = status === 'rejected' && rejectionReason
            ? `Motivo del rifiuto: ${rejectionReason}`
            : "";

        const templateParams = {
            to_email: userEmail,
            user_name: userName || "Utente",
            space_id: spaceId,
            event_name: eventName,
            status: statusText,
            rejection_reason: reasonText
        };

        const response = await emailjs.send(
            EMAILJS_CONFIG.SERVICE_ID,
            EMAILJS_CONFIG.TEMPLATE_STATUS_UPDATE,
            templateParams,
            EMAILJS_CONFIG.PUBLIC_KEY
        );

        console.log('Email to user sent successfully!', response.status, response.text);
        return true;
    } catch (err) {
        console.error('Failed to send email to user:', err);
        return false;
    }
};
